import {
  GET_POI_CATEGORIES_FOR_SELECTED_LEVEL,
  GET_INDOOR_ZONE_DATA_FOR_LEVEL
} from '@/store/action-types'
import {
  SET_POIS_FOR_SELECTED_LEVEL,
  SET_POI_CATEGORIES_FOR_SELECTED_LEVEL
} from '@/store/mutation-types'
import { POI_CATEGORY, POI } from '@/interfaces/poi.interface'
import { getSensordata } from '@/services/sensorData.service'

import { getCategoriesForLevel, getPoisForSelectedLevelPerCategory } from '@/services/pois.service'
import { getPoiWithAddedProperties } from '@/utils/data'
import { getZoneCategories, getZoneTypeFeaturesV2 } from '@/services/zones.service'
import i18n from '../../../i18n'
import { useIotCoverageStore } from '@/pinia/iotCoverage'
const { t } = i18n.global

export default {
  async [GET_INDOOR_ZONE_DATA_FOR_LEVEL]({ commit, state }, payload) {
    const filteredLayers = [...state.filteredLayers]
    const isTypeDataAlreadyFetched = state.indoorZonesForSelectedLevel.some(
      (feature) => feature.properties.typeId === payload.typeId
    )
    if (!isTypeDataAlreadyFetched) {
      const zoneFeaturesForType = await getZoneTypeFeaturesV2(
        payload.levelId,
        payload.categoryId,
        payload.typeId
      )
      if (!zoneFeaturesForType) return
      const selectedType = zoneFeaturesForType.filter(
        (type) => type.properties.typeId === payload.typeId
      )
      const existingZonesArray = state.indoorZonesForSelectedLevel
      const zonesArray = existingZonesArray.concat(selectedType)
      commit('SET_INDOOR_ZONE_DATA_FOR_LEVEL', { zones: zonesArray })
      const zoneCategory = state.filteredLayers.find(
        (category) => category.id === payload.categoryId
      )
      const zoneTypeInfo = zoneCategory.types.find((type) => type.id === payload.typeId)
      zoneTypeInfo.visible = payload.checked
      zoneCategory.visible =
        zoneCategory.types.filter((x) => x.visible === true).length === zoneCategory.types.length
    }

    if (isTypeDataAlreadyFetched) {
      filteredLayers.forEach((layer) => {
        layer.types.forEach((type) => {
          if (type.id === payload.typeId) {
            type.visible = payload.checked
            layer.visible =
              layer.types.filter((x) => x.visible === true).length === layer.types.length
          }
        })
      })
    }
    commit('SET_FILTERED_PLANVIEW_LAYERS', { filteredLayers })
  },
  async [GET_POI_CATEGORIES_FOR_SELECTED_LEVEL]({ commit }, levelId: string) {
    try {
      const fetchedPoiCategories: POI_CATEGORY[] = await getCategoriesForLevel(levelId)
      const poiCategories = fetchedPoiCategories ? fetchedPoiCategories : []
      poiCategories.forEach((category) => {
        category.types.forEach((type) => {
          type.visible = false
          type.disabled = false
        })
        category.visible = false
      })
      commit(SET_POI_CATEGORIES_FOR_SELECTED_LEVEL, poiCategories)
    } catch (e) {
      console.error(e)
    }
  },
  async getPoisForLevelPerCategory({ commit, state }, payload) {
    if (!payload.typeId || !payload.categoryId || !payload.levelId) return
    const poisForSelectedLevel = [...state.poiCategoriesForSelectedLevel]
    const isCategoryAlreadyFetched = state.poisForSelectedLevel.some(
      (feature) => feature.properties.typeId === payload.typeId
    )
    if (!isCategoryAlreadyFetched) {
      const fetchedPoiTypes = await getPoisForSelectedLevelPerCategory(
        payload.categoryId,
        payload.levelId,
        payload.typeId
      )
      const updatedPois: POI[] = []
      if (fetchedPoiTypes)
        fetchedPoiTypes.forEach((poi) =>
          updatedPois.push(getPoiWithAddedProperties(poi, state.poiCategoriesForSelectedLevel))
        )
      if (updatedPois?.length) {
        const existingPoisArray = [...state.poisForSelectedLevel]
        const poisArray = existingPoisArray.concat(updatedPois)
        commit(SET_POIS_FOR_SELECTED_LEVEL, poisArray)
        const poiCategory = state.poiCategoriesForSelectedLevel.find(
          (category) => category.id === payload.categoryId
        )
        const poiTypeInfo = poiCategory.types.find((type) => type.id === payload.typeId)
        poiTypeInfo.visible = payload.checked
        poiCategory.visible =
          poiCategory.types.filter((x) => x.visible === true).length === poiCategory.types.length
      }
    }
    if (isCategoryAlreadyFetched) {
      poisForSelectedLevel.forEach((layer) => {
        layer.types.forEach((type) => {
          if (type.id === payload.typeId) {
            type.visible = payload.checked
            layer.visible =
              layer.types.filter((x) => x.visible === true).length === layer.types.length
          }
        })
      })
    }
    commit(SET_POI_CATEGORIES_FOR_SELECTED_LEVEL, poisForSelectedLevel)
  },
  // fetch pois by category and add them to the store
  // if (!poisForSelectedLevel.length) {
  //  const pois = await fetchAndUpdatePois(categoryId, rootState.selectedLevel.id)
  //  commit(SET_POIS_FOR_SELECTED_LEVEL, pois)
  //  } else if (
  //    poisForSelectedLevel.length &&
  //    state.poiCategoriesForSelectedLevel.some((category) => category.visible) &&
  //    !isCategoryAlreadyFetched(poisForSelectedLevel, categoryId)
  // ) {
  //   const pois = await fetchAndUpdatePois(categoryId, rootState.selectedLevel.id)
  //   const poisForSelectedLevelPerCategory = pois.concat(...poisForSelectedLevel)
  //   if (poisForSelectedLevel !== poisForSelectedLevelPerCategory) {
  //     commit(SET_POIS_FOR_SELECTED_LEVEL, poisForSelectedLevelPerCategory)
  //   }
  //  }
  // },
  async loadSensorData({ dispatch, rootGetters }) {
    if (rootGetters.hasSensorDataAccess) await dispatch('getSensordataForSelectedLevel')
  },
  async onLevelChange({ commit, dispatch, rootGetters }, levelId: string) {
    commit('SET_POIS_FOR_SELECTED_LEVEL', [])
    commit('SET_INDOOR_ZONE_DATA_FOR_LEVEL', { zones: [] })
    if (rootGetters.hasPoiReaderAccess)
      await dispatch('GET_POI_CATEGORIES_FOR_SELECTED_LEVEL', levelId)
    if (rootGetters.hasZoneAccess) {
      const zoneCategoriesForSelectedLevel = await getZoneCategories(levelId)
      if (zoneCategoriesForSelectedLevel) {
        commit('SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL', {
          categories: zoneCategoriesForSelectedLevel.data.content
        })
        const filteredLayers: object[] = []
        zoneCategoriesForSelectedLevel.data.content.forEach((category) => {
          category.types.forEach((type) => {
            type.visible = false
            type.disabled = false
          })
          filteredLayers.push({
            disabled: false,
            id: category.id,
            name: category.name,
            types: category.types,
            visible: false
          })
        })
        commit('SET_FILTERED_PLANVIEW_LAYERS', { filteredLayers })
      }
    }
  },
  async getSensordataForSelectedLevel({ commit, rootState }) {
    const { levels } = useIotCoverageStore()
    try {
      commit('setSensordataTypes', [])
      commit('setSensordataForSelectedLevel', [])
      if (!levels.includes(rootState.selectedLevel.id)) return
      commit('setIsLoadingSensordata', true)
      const sensorDataLevel = await getSensordata(rootState.selectedLevel.id, true, 15000)
      const uniqueMeasureTypes: string[] = []
      sensorDataLevel.values.filter((roomValues) => {
        roomValues.values.forEach((value) => {
          if (!uniqueMeasureTypes.includes(value.measures)) uniqueMeasureTypes.push(value.measures)
        })
      })
      commit('setSensordataTypes', uniqueMeasureTypes)
      commit('setSensordataForSelectedLevel', sensorDataLevel.values)
    } catch (e: any) {
      if (e.constructor.name !== 'Cancel')
        commit(
          'setInfoMessage',
          { type: 'error', message: t('message__sensor-data-fetch-error') },
          { root: true }
        )
      commit('setSensordataForSelectedLevel', [])
      console.error(e)
    } finally {
      commit('setIsLoadingSensordata', false)
    }
  }
}
